// import {testURL} from '../url/index'
import request from '@/util/request'

export function base64 (data) {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/utils/base64',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/base64.js